import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTranslate, useTranslation } from 'hooks/use-translation';
import { BaseWidget } from '../common';
import { TitleWithTooltip } from './components';
import {
  DurationData,
  loadingRender,
  noDataMessageFormatter,
  noDataRender,
} from './renderers';
import { WidgetState } from './state';

interface Props<T, E> {
  value: WidgetState<T, E>;
}
export const AverageProjectStartTime: FC<Props<number, unknown>> = ({
  value,
}) => {
  const translate = useTranslate();
  const resultRenderer = (result: number) => <DurationData value={result} />;

  return (
    <BaseWidget>
      <BaseWidget.Title
        text={
          <TitleWithTooltip
            title={useTranslation(
              'reports.project_performance.widget.average_project_start_time.title',
            )}
            tooltip={useTranslation(
              'reports.project_performance.widget.average_project_start_time.description',
            )}
          />
        }
      />
      <BaseWidget.Content>
        {WidgetState.map(resultRenderer, loadingRender, () =>
          noDataRender(
            noDataMessageFormatter(
              <FormattedMessage id="reports.project_performance.widget.average_project_start_time.no_value" />,
              translate,
            ),
          ),
        )(value)}
      </BaseWidget.Content>
    </BaseWidget>
  );
};
